import { createContext, useState } from "react";

export const CardContext = createContext({});

export const CardProvider = (props) => {
    const [cardInfo, setCardInfo] = useState({ittengo: {}, message: ''});
    return(
        <CardContext.Provider value={{cardInfo, setCardInfo}}>
            {props.children}
        </CardContext.Provider>
    )
}